import { useCallback, useEffect, useRef, useState } from 'react';
import './MobileSidebar.scss';
import Drawer from '@mui/material/Drawer';
import { useAppSelector } from '../../redux/app/hooks';
import { useDispatch } from 'react-redux';
import { logout, setIsSidebarOpen, setSplashvisible, setSelectedTabindex, setRefetchNotification, setSystemMessagesCount } from '../../redux/slices/authSlice';
import images from '../../assets/images';
import Tooltip from '@mui/material/Tooltip';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FETCH_POLICY, FETCH_POLICY_NO_CACHE, LOGOUT_MESSAGE_IN_MEETING_HOST, LOGOUT_MESSAGE_IN_MEETING_PARTICIPANT, LOGOUT_MESSAGE_NOT_IN_MEETING, PATH_ADDRESSES, PTA_ROLE, SCHOOL_ADMIN, STUDENT_ROLE, TEACHER_ROLE, VIRTUAL } from '../../utils/constants';
import { getIsJoinedLocalValue, getLocalParticipantId, getScreenDimensions } from '../../utils/helper';
import { useLazyQuery, useMutation } from '@apollo/client';
import { GET_CHAT_INDICATION, GET_CLASSROOM_UPDATES, GET_NOTIFICATIONS } from '../../pages/TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import { GET_ALL_MEETING_CATEGORIES, UPDATE_MEETING_STATUS } from '../../pages/AdminPta/api/PtaQuery';
import { MeetingCategoryType } from '../../pages/AdminPta/AdminPta';
import ToasterWithMessage from '../toaster';
import { setCategoryListLoading, setCurrentSessionRecordingDetail, setIsStartingMeeting } from '../../redux/slices/dashboardSlice';
import { GetChatCountResponse, GetClassroomUpdatesResponse, GetClassroomUpdatesVariables } from '../../pages/TeacherStudentClassroom/types/TeacherStudentClassroom';
import { setChatTabIndication, setTabIndication } from '../../redux/slices/indication';
import { DELETE_SESSION_PARTICIPANT, UPDATE_SESSION_RECORD } from '../../Chime/helpers/Api/ChimeApi';
import { UPDATE_WORKSHOP_ENDED, UPDATE_WORKSHOP_MEETING_ID } from '../../pages/Workshop/api/WorkshopQuery';
import { END_THE_LIVE_SESSION } from '../../pages/LiveClass/api/LiveClassQuery';
import { UPDATE_ACTIVE_STATUS } from '../../pages/CommonChats/api/ChatsQuery';
import { SYSTEM_MESSAGES_FROM_KATON, SYSTEM_MESSAGES_TOTAL_COUNT } from '../../pages/AdminSystemMessages/api/AdminSystemMessages';
import { trackButtonClick } from '../../firebase/analyticsHelper';
import { ButtonClickEvents } from '../../firebase/constants/events';

interface NotificationType{
    Announcement?: number;
    Calender?: number;
    Workshop?: number;
    Ptameetings?: number;
}

const drawerStyle = {
    '& .MuiPaper-root': {
        width: getScreenDimensions()?.width > 375 ? '300px' : '250px',
        height: '100%',
        padding: '0px'
    }
};

const MobileSidebar = () => {

    const { logoutGif, logoutIconMobile, classroomActiveIcon, classroomInactiveIcon, announcementActiveIcon, 
    announcementInactiveIcon, settings_active, settings_inactive, MobileNotificationActive, MobileNotificationInactive,
    MobileDashboardActive, MobileDashboardInactive, MobileWorkshopActive, MobileWorkshopInactive,
    MobileSystemMessageActive, MobileSystemMessageInactive, MobileHelp, workshopParticipantActive, workshopParticipantInactive, 
    AnnouncementIconActive, AnnouncementIconInActive, mobileGeneralMeetingInActive, mobileGeneralMeetingActive, 
    ptaOtherMeetingActive, ptaOtherMeetingInactive,ActiveCalendarIcon,InActiveCalendarIcon, UploadIconDashboard, bookIconGrey, paymentIcon, paymentIconActive } = images;
    const { adminProfileImage: profileImage, isSidebarOpen, role, adminProfile: profile } = useAppSelector((state) => state?.auth);
    const dispatch = useDispatch();
    const schoolNameRef = useRef<HTMLDivElement | null>(null);
    const [isOverflow, setIsOverflow] = useState(false);
    const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
    const navigate = useNavigate();
    const location = useLocation();
    const StudentName = profile?.getCurrentUser?.nodes?.[0]?.uFullName;
    const classRoomName = useAppSelector((state) => state.auth.selectedClassRoomName);
    const tab = role === SCHOOL_ADMIN ? localStorage?.getItem('adminDashboardTabIndex') : localStorage?.getItem('teacherStudentTabIndex');
    const [activeTab, setActiveTab] = useState(tab ? parseInt(tab) : null);
    const isMylibaryActive = useAppSelector((state) => state.indication.indication.myLibary)
    const isLiveActive = useAppSelector((state) => state.indication.indication.live)
    const [notification, setNotification] = useState<NotificationType>();
    const refetchNotification = useAppSelector((state) => state?.auth?.refetchNotification);
    const textRef = useRef<HTMLDivElement>(null);
    const [isEllipsisActive, setIsEllipsisActive] = useState(false);
    const selectedCategory: MeetingCategoryType = location?.state?.category;
    const { error } = ToasterWithMessage();
    const [allCategory, setAllCategory] = useState<MeetingCategoryType[]>([]);
    const [oneMenuItems, setOneMenuItems] = useState<any>([]);
    const isquizActive = useAppSelector((state) => state.indication.indication.quiz)
    const isAssignmentActive = useAppSelector((state) => state.indication.indication.assignment)
    const [showPtaSideBar, setShowPtaSideBar] = useState<boolean>(false);
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const schoolType = useAppSelector((state) => state.auth.schoolType);
    const isChime = process.env.REACT_APP_COMMON_CHAT_SERVICE === 'CHIME';
    const [logoutMessage, setLogoutMessage] = useState<string>('');
    const { currentSessionId, currentWorkshopId, currentPtaMeetId, currentUserId } = useAppSelector((state) => state?.dashboard);
    const meetComponent = useAppSelector((state) => state?.dashboard?.meetComponent);
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const meetService = useAppSelector((state) => state.auth.meetService);
    const isMeetRecording = localStorage.getItem("isMeetRecording");
    const systemMessageCount = useAppSelector((state) => state?.auth?.systemMessagesCount);

    const [systemMessagesTotalCount] = useLazyQuery(SYSTEM_MESSAGES_TOTAL_COUNT, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            dispatch(setSystemMessagesCount(data?.allSystemMessages?.totalCount || 0));
        }
    });

    const [systemMessagesFromKaton] = useLazyQuery(SYSTEM_MESSAGES_FROM_KATON, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: () => {
            systemMessagesTotalCount();
        }
    });

    useEffect(() => {
        if (role === SCHOOL_ADMIN) {
            systemMessagesFromKaton();
        }
    }, [role]);

    const [getAllMeetingCategory, { loading: categoryLoading }] = useLazyQuery(GET_ALL_MEETING_CATEGORIES, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            const ptaMenuItems: any = []
            setAllCategory(data?.allMeetingCategories?.nodes);
            data?.allMeetingCategories?.nodes?.map((val: MeetingCategoryType, index: number) => {
                if (index === 0 && (role === PTA_ROLE || role === TEACHER_ROLE)) {
                    localStorage.setItem("generalCode", val?.mcCode);
                }
                ptaMenuItems.push({
                    id: val?.mcCode,
                    label: val?.mcOriginalType,
                    link: PATH_ADDRESSES?.PTA_MEETINGS_PATH,
                    inactiveIcon: (index === 0 ? mobileGeneralMeetingInActive : ptaOtherMeetingActive),
                    activeIcon: (index === 0 ? mobileGeneralMeetingActive : ptaOtherMeetingActive),
                    set: "setOne",
                    category: val
                });
            })
            if (role === PTA_ROLE && selectedCategory === undefined) {
                localStorage.setItem('isVerify','false');
                navigate(ptaMenuItems?.[0]?.link, {
                    state: {
                        category: data?.allMeetingCategories?.nodes?.[0]
                    }
                });
            }
            setOneMenuItems(ptaMenuItems);
        },
        onError: (err) => {
            error(err?.message);
        }
    });

    useEffect(() => {
        dispatch(setCategoryListLoading({ categoryListLoading: categoryLoading }))
    },[categoryLoading])

    const [getClassRoomUpdates] = useLazyQuery<
        GetClassroomUpdatesResponse,
        GetClassroomUpdatesVariables
      >(GET_CLASSROOM_UPDATES, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
          const { quiz, assignments, mylibrary, ebooks, isStudentHaveAccess } = data.getClassroomUpdates;
          if (role === STUDENT_ROLE && isStudentHaveAccess === false) {
            error("Your Access has been revoked!");
            setTimeout(() => {
              dispatch(logout());
              dispatch(setSplashvisible());
            }, 2000);
            return;
          }
          const quizCount = quiz.totalCount;
          const hasQuiz = quizCount > 0;
          const assignmentCount = assignments.totalCount;
          const hasAssignment = assignmentCount > 0;
          const myLibrayCount = mylibrary.totalCount;
          const ebooksCount = ebooks.totalCount;
          const hasMylibrary = myLibrayCount > 0;
          const hasEbooks = ebooksCount > 0;
    
          // Set tab indication based on either quiz or assignment presence
          dispatch(
            setTabIndication(hasQuiz || hasAssignment || hasMylibrary || hasEbooks)
          );
        },
        onError: (err) => {
          console.log(err.message);
        },
      });
    
      //indication for chat
      const [getIndicationChat] = useLazyQuery<
        GetChatCountResponse,
        GetClassroomUpdatesVariables
      >(GET_CHAT_INDICATION, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
          const chatCount = data.getAllChatCount;
          const hasChat = chatCount > 0;
          dispatch(setChatTabIndication(hasChat));
        },
        onError: (err) => {
          console.log(err.message);
        },
      });

    const schoolAdminMenus = [
        { id: 'Dashboard', label: "Dashboard", inactiveIcon: MobileDashboardInactive, activeIcon: MobileDashboardActive, link: PATH_ADDRESSES?.ADMIN_DASHBOARD_PATH , set: "setOne"},
        { id: 'Upload', label: "Upload", inactiveIcon: UploadIconDashboard, activeIcon: UploadIconDashboard , link: "/admin-materials-upload", set: "setOne" },
        ...(schoolType === VIRTUAL
          ? [{ id: 'Payments', label: "Payments", inactiveIcon: paymentIcon, activeIcon: paymentIconActive, link: "/admin-payments", set: "setOne" }]
          : []
        ),
        { id: 'Workshop', label: "Workshop", inactiveIcon: MobileWorkshopInactive, activeIcon: MobileWorkshopActive, link: "/admin-workshop" , set: "setOne"},
        { id: 'Notification', label: "Notification", inactiveIcon: MobileNotificationInactive, activeIcon: MobileNotificationActive, link: "/admin-notification" , set: "setOne"},
        { id: 'SystemMessages', label: "System Messages", inactiveIcon: MobileSystemMessageInactive, activeIcon: MobileSystemMessageActive, link: "/admin-system-message" , set: "setOne"},
    ];

    const teacherStudentMenus = [
        { id: 'Classroom', label: "Classroom", inactiveIcon: classroomInactiveIcon, activeIcon: classroomActiveIcon, link: role === STUDENT_ROLE ? PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH : PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH , set: "setOne", hasSubmenu: true, submenus : [
            { id: 'MyLibrary', label: "My Library" , index: 0},
            { id: 'Quiz', label: "Quiz" , index: 1},
            { id: 'Assignment', label: "Assignment" , index: 2},
            { id: 'Chats', label: "Chats" , index: 3},
            { id: 'LiveClass', label: "Live Class" , index: 4}
        ]},
        ...((role === TEACHER_ROLE && schoolType !== VIRTUAL) ? [{ id: 'Workshop', label: "Workshop", inactiveIcon: workshopParticipantInactive, activeIcon: workshopParticipantActive, link: "/teacher-workshop" , set: "setOne", notificationKey: 'Workshop'}]:[]),
        ...(schoolType !== VIRTUAL ? [{ id: 'Calendar', label: "Calendar", inactiveIcon: InActiveCalendarIcon, activeIcon: ActiveCalendarIcon, link: role === STUDENT_ROLE ? "/student-calendar" : "/teacher-calendar" , set: "setOne", notificationKey: 'Calender'}]:[]),
        { id: 'Announcement', label: "Announcement", inactiveIcon: AnnouncementIconInActive, activeIcon: AnnouncementIconActive, link: role === STUDENT_ROLE ? "/student-announcement" : "/teacher-announcement" , set: "setOne", notificationKey: 'Announcement'},
        ...((role === TEACHER_ROLE && schoolType !== VIRTUAL && allCategory?.length > 0) ? [{ id: 'PTAMeetings', label: "PTA Meetings", inactiveIcon: mobileGeneralMeetingInActive, activeIcon: mobileGeneralMeetingActive, link: PATH_ADDRESSES?.TEACHER_PTA_PATH , set: "setOne", hasSubmenu: true, notificationKey: 'Ptameetings', submenus : allCategory?.map((value, index) => ({ id: value?.mcCode, label: value?.mcOriginalType, index, link: PATH_ADDRESSES?.TEACHER_PTA_PATH, category: value }))}]:[]),
    ];

    const menuItems = [
        ...(role === SCHOOL_ADMIN ? schoolAdminMenus : role === PTA_ROLE ? oneMenuItems : teacherStudentMenus),
        ...((role !== PTA_ROLE) ? [{ id: 'Settings', label: "Settings", inactiveIcon: settings_inactive, activeIcon: settings_active, link: (role === SCHOOL_ADMIN ? "/admin-settings" : role === TEACHER_ROLE ? "/teacher-settings" : "/student-settings"), set: "setTwo" },
        ...(role === SCHOOL_ADMIN || schoolType !== VIRTUAL ? [{ id: 'Help', label: "Help", inactiveIcon: MobileHelp, activeIcon: MobileHelp, link: (role === SCHOOL_ADMIN ? "/admin-help" : role === TEACHER_ROLE ? "/teacher-help" : "/student-help"), set: "setTwo" }] : [])] : []),
        { id: 'Logout', label: "Logout", inactiveIcon: logoutIconMobile, activeIcon: logoutIconMobile, link: "/", set: "setThree" },
    ];

    const toggleSidebar = (newOpen: boolean) => () => {
        dispatch(setIsSidebarOpen({ isSidebarOpen: newOpen }));
    };

    const checkOverflow = () => {
        if (schoolNameRef.current) {
          setIsOverflow(schoolNameRef.current.scrollWidth > schoolNameRef.current.clientWidth);
        }
    };

    const [updateChatActiveStatus] = useMutation(UPDATE_ACTIVE_STATUS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    });

    const [deleteSessionParticipant] = useMutation(DELETE_SESSION_PARTICIPANT, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
            console.log("Participant deleted successfully:", data);
        },
        onError: (err) => {
            console.log(err);
        },
    });

    const [updateSessionRecord] = useMutation(UPDATE_SESSION_RECORD, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    });  

    const [updateWorkshopSession] = useMutation(UPDATE_WORKSHOP_MEETING_ID, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    });  
    
    const [updatePtaMeeting] = useMutation(UPDATE_MEETING_STATUS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    }); 

    const [updateSessionEnd] = useMutation(END_THE_LIVE_SESSION, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    });   
    
    const [updateWorkshopEnd] = useMutation(UPDATE_WORKSHOP_ENDED, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    });

    const handleDeleteParticipant = useCallback(async () => {
        console.log("[logout] all values", meetComponent, currentSessionId, selectedSubjectId, selectedClassRoomId, getLocalParticipantId(meetService || ''));
        if (
            meetComponent === "liveclass" &&
            currentSessionId &&
            selectedSubjectId &&
            selectedClassRoomId
        ) {
            deleteSessionParticipant({
                variables: {
                    cId: selectedClassRoomId,
                    sId: currentSessionId,
                    sjId: selectedSubjectId,
                    participantId: getLocalParticipantId(meetService || ''),
                },
            });
        }
    }, [meetComponent, currentSessionId, selectedSubjectId, selectedClassRoomId, meetService, deleteSessionParticipant]);

    const handleUpdateRecordTime = useCallback(async (recordingStatus: boolean, recordStartTime: string) => {
        if (meetComponent === "liveclass" && selectedClassRoomId && currentSessionId && selectedSubjectId) {
            await updateSessionRecord({
                variables: {
                    cId: selectedClassRoomId,
                    sId: currentSessionId,
                    sjId: selectedSubjectId,
                    isRecordStart: recordingStatus,
                    recordStarttime: recordStartTime,
                },
            });
        } else if (meetComponent === "workshop" && currentWorkshopId) {
            await updateWorkshopSession({
                variables: {
                    updateInput: {
                        isRecordStart: recordingStatus,
                        recordStartTime: recordStartTime,
                    },
                    wsId: currentWorkshopId,
                }
            });
        } else if (meetComponent === "pta" && currentPtaMeetId) {
            await updatePtaMeeting({
                variables: {
                    updateInput: {
                        isRecordStart: recordingStatus,
                        recordStartTime: recordStartTime,
                    },
                    mId: currentPtaMeetId,
                }
            });
        }
        localStorage.setItem("isMeetRecording", recordingStatus ? "true" : "false");
        dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: recordStartTime, recordingStarted: recordingStatus }));
    }, [meetComponent, selectedClassRoomId, currentSessionId, selectedSubjectId, currentWorkshopId, currentPtaMeetId, updateSessionRecord, updateWorkshopSession, updatePtaMeeting, dispatch]);  
    
    const updateEndMeeting = useCallback(async () => {
        console.log("[Log] updateEndMeeting called");
        if (meetComponent === "liveclass" && ((role === TEACHER_ROLE) || (localStorage.getItem('hostId')?.includes(currentUserId))) && selectedSubjectId && currentSessionId && selectedClassRoomId) {
            await updateSessionEnd({
                variables: {
                    cId: selectedClassRoomId,
                    sId: currentSessionId,
                    sjId: selectedSubjectId,
                },
            });
        } 
        else if (meetComponent === "workshop" && ((role === SCHOOL_ADMIN) || (localStorage.getItem('hostId')?.includes(currentUserId))) && currentWorkshopId) {
            await updateWorkshopEnd({
                variables: {
                    wsId: currentWorkshopId,
                },
            });
        } 
        else if (meetComponent === "pta" && ((role === SCHOOL_ADMIN) || (localStorage.getItem('hostId')?.includes(currentUserId))) && currentPtaMeetId) {
            await updatePtaMeeting({
                variables: {
                    updateInput: {
                        mStatus: "ENDED",
                    },
                    mId: currentPtaMeetId,
                },
            });
        } 
    }, [meetComponent, role, selectedSubjectId, currentSessionId, selectedClassRoomId, currentWorkshopId, currentPtaMeetId, updateSessionEnd, updateWorkshopEnd, updatePtaMeeting, currentUserId]);

    const onYesButtonClick = async () => {
        setOpenConfirmationPopup(false);
        dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
        if ((role === TEACHER_ROLE || role === STUDENT_ROLE)) {
            await updateChatActiveStatus({
                variables: {
                    chatActive: false
                }
            })
            .catch((error) => {
                console.error("Failed to update chat active status:", error);
            });
        }  
        if (getLocalParticipantId(meetService || '') && getLocalParticipantId(meetService || '') !== "") {
            await handleDeleteParticipant();
        } 

        if (isMeetRecording === "true") {
            await handleUpdateRecordTime(false, new Date().toISOString());
        }
        
        const isJoined = getIsJoinedLocalValue();
        if (isJoined === 'joined') {
            await updateEndMeeting();
        }
        
        trackButtonClick(ButtonClickEvents?.LOGOUT_BUTTON_CLICK, {
            description: "User clicks the logout button",
        });
        dispatch(logout());
        dispatch(setSplashvisible());
    };

    const onNoButtonClick = () => {
        setOpenConfirmationPopup(false);
    };

    const onLogoutClick = () => {
        const isJoined = getIsJoinedLocalValue();

        if (isJoined && isJoined === "joined") {
            if (((meetComponent === 'liveclass') && ((role === TEACHER_ROLE) || (localStorage.getItem('hostId')?.includes(currentUserId)))) || 
                ((meetComponent === 'workshop') && ((role === SCHOOL_ADMIN) || (localStorage.getItem('hostId')?.includes(currentUserId)))) || 
                ((meetComponent === 'pta') && ((role === SCHOOL_ADMIN) || (localStorage.getItem('hostId')?.includes(currentUserId))))) {
                setLogoutMessage(LOGOUT_MESSAGE_IN_MEETING_HOST);  
            } else {
                setLogoutMessage(LOGOUT_MESSAGE_IN_MEETING_PARTICIPANT);
            }
        } else {
            setLogoutMessage(LOGOUT_MESSAGE_NOT_IN_MEETING);
        }
        setOpenConfirmationPopup(true);
    };

    const getMenuItemsBySet = (set: string) => {
        return menuItems.filter(item => item.set === set);
    };

    const [getNotifications] = useLazyQuery(GET_NOTIFICATIONS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
            setNotification(data?.notifyUser);
        },
    });

    useEffect(() => {
        if (role !== PTA_ROLE) {
            getNotifications();
        }
        if (role && [TEACHER_ROLE, PTA_ROLE]?.includes(role)) {
            getAllMeetingCategory();
        }
    }, []);

    useEffect(() => {
        if (role !== PTA_ROLE && refetchNotification) {
            getNotifications();
            dispatch(setRefetchNotification({ refetchNotification: false }));
        }
    }, [refetchNotification]);

    useEffect(() => {
        if (selectedClassRoomId && role === STUDENT_ROLE) {
            getClassRoomUpdates({
                variables: {
                    cId: selectedClassRoomId ?? ''
                }
            });
            getIndicationChat({
                variables: {
                    cId: selectedClassRoomId ?? "",
                    messagingProvider: isChime ? 'CHIME' : 'WEBSOCKET'
                },
            });
        }
    }, [role, selectedClassRoomId, isChime]);

    const onMenuClick = async (menu: any) => {
        if (role !== PTA_ROLE) {
            await getNotifications();
        }
        if ((role === TEACHER_ROLE || role === STUDENT_ROLE) && (menu?.id !== 'Classroom' && menu?.id !== 'classroom')) {
            updateChatActiveStatus({
                variables: {
                    chatActive: false
                }
            });
        }
        if (role === STUDENT_ROLE) {
            getClassRoomUpdates({
                variables: {
                    cId: selectedClassRoomId ?? ''
                }
            });
            getIndicationChat({
                variables: {
                    cId: selectedClassRoomId ?? "",
                    messagingProvider: isChime ? 'CHIME' : 'WEBSOCKET'
                },
            });
        }
        if (activeTab === null && menu?.link === PATH_ADDRESSES?.ADMIN_DASHBOARD_PATH) {
            setActiveTab(0);
        }
        if (menu?.link === PATH_ADDRESSES?.ADMIN_DASHBOARD_PATH) {
            setActiveTab(null);
        }
        dispatch(setIsSidebarOpen({ isSidebarOpen: false }));
        if (menu?.link === PATH_ADDRESSES?.TEACHER_PTA_PATH || menu?.link === PATH_ADDRESSES?.PTA_MEETINGS_PATH) {
            if (role === PTA_ROLE) {
                localStorage.setItem('isVerify','false');
            }
            navigate(menu?.link, {
                state: {
                    category: role === PTA_ROLE ? menu?.category : menu?.submenus?.[0]?.category
                }
            });
        }
        else {
            navigate(menu?.link);
        }
    };

    const handleSubmenuClick = (submenu:any) => {
        dispatch(setIsSidebarOpen({ isSidebarOpen: false }));
        if (submenu?.link && submenu?.category) {
            navigate(submenu?.link, {
                state: { category: submenu?.category }
            });
            if (role === TEACHER_ROLE) {
                localStorage.setItem('isVerify','false');
            }
        }
        else {
            setActiveTab(submenu?.index);
            localStorage.setItem(role === SCHOOL_ADMIN ? 'adminDashboardTabIndex' :'teacherStudentTabIndex', String(submenu?.index));
            dispatch(setSelectedTabindex({selectedTabindex: String(submenu?.index)}));
            navigate(role === SCHOOL_ADMIN ? PATH_ADDRESSES?.ADMIN_DASHBOARD_PATH : role === STUDENT_ROLE ? PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH : PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
        }
    }    

    const checkEllipsis = useCallback(() => {
        if (textRef.current) {
        setIsEllipsisActive(textRef.current.scrollWidth > textRef.current.clientWidth);
        }
    }, []);

    useEffect(() => {
        checkEllipsis();
        window.addEventListener("resize", checkEllipsis);
        return () => window.removeEventListener("resize", checkEllipsis);
    }, [checkEllipsis, StudentName]);

    const handleClickSchoolProfile = () => {
        if (location.pathname === PATH_ADDRESSES?.TEACHER_PTA_PATH || location.pathname === PATH_ADDRESSES?.PTA_MEETINGS_PATH) {
          setShowPtaSideBar(true);
        }
        if (role !== PTA_ROLE) {
          getNotifications();
        }
        if(role === STUDENT_ROLE){
            getClassRoomUpdates({
              variables :{
                cId : selectedClassRoomId ?? ''
              }
            })
            // if(schoolType !== VIRTUAL){
            getIndicationChat({
              variables: {
                cId: selectedClassRoomId ?? "",
                messagingProvider: isChime ? 'CHIME' : 'WEBSOCKET'
              },
            });
        //   }
          }
        dispatch(setIsSidebarOpen({ isSidebarOpen: false }))
        if (location.pathname !== "/school-profile") {
          navigate("/school-profile", {
            state: {
              backNavigation: location.pathname,
              category: selectedCategory
            }
          });
        }
      };

    return (
        <Drawer open={isSidebarOpen} onClose={toggleSidebar(false)} sx={drawerStyle}>
            <div className='sidebarContainer'>
                <div className='sidebarTopContainer'>
                    <div className='profileContainer' onClick={handleClickSchoolProfile}>
                        <div className='profileImageContainer'>
                            {profileImage && <img src={profileImage} className='profile' alt='profile' />}
                        </div>
                        <div className='nameContainer'>
                            <Tooltip
                                title={`${profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName ? profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName : "Katon Virtual School"}`}
                                disableHoverListener={!isOverflow}
                                placement="top"
                            >
                                <div className="name" ref={schoolNameRef} onMouseEnter={checkOverflow}>
                                    {`${profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName ? profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName : "Katon Virtual School"}`}
                                </div>
                            </Tooltip>
                            {
                                role === STUDENT_ROLE
                                ?
                                <div className='role'>
                                    <Tooltip title={isEllipsisActive ? StudentName || "Student" : ""} arrow>
                                        <div
                                            ref={textRef}
                                            className="namefield">
                                            {StudentName || "Student"}
                                        </div>
                                    </Tooltip>
                                    <div>{(profile?.getCurrentUser?.nodes?.[0]?.studentsByUId?.nodes?.[0]?.studentClassroomsBySId?.nodes?.[0]?.classroomByCId?.cOriginalName && profile?.getCurrentUser?.nodes?.[0]?.studentsByUId?.nodes?.[0]?.studentClassroomsBySId?.nodes?.[0]?.classroomByCId?.cOriginalName !== "") && <span>{profile?.getCurrentUser?.nodes?.[0]?.studentsByUId?.nodes?.[0]?.studentClassroomsBySId?.nodes?.[0]?.classroomByCId?.cOriginalName}</span>}</div>
                                </div>
                                : role === TEACHER_ROLE ?
                                <div className='role'>
                                    <div className='namefield'>{`${StudentName ? StudentName : 'Teacher'}`}</div>
                                    <div>
                                        {(classRoomName && classRoomName !== "") && <span>{classRoomName}</span>}
                                    </div>
                                </div>
                                : <div className='role'>{role}</div>
                            }
                        </div>
                    </div>
                    {role === SCHOOL_ADMIN &&
                    <div className={"adminSidebarCards"}>
                              <Link to={"/admin-school"} onClick={() => dispatch(setIsSidebarOpen({ isSidebarOpen: false }))} className={`adminSidebarSchoolCard ${location.pathname === "/admin-school" ? "adminSidebarSelectedCard" : ""}`}>
                                <label htmlFor="customize-school" className="adminSidebarSchoolLabel">Customize</label>
                                <span className="adminSidebarSchoolText">School</span>
                              </Link>
                              <Link to={"/admin-calendar"} onClick={() => dispatch(setIsSidebarOpen({ isSidebarOpen: false }))} className={`adminSidebarCalendarCard ${location.pathname === "/admin-calendar" ? "adminSidebarSelectedCard" : ""}`}>
                                <label htmlFor="edit-calendar" className="adminSidebarCalendarLabel">Edit</label>
                                <span className="adminSidebarCalendarText">Calendar</span>
                              </Link>
                    </div>}
                    <div className='menuItems'>
                        {getMenuItemsBySet("setOne").map((item: any, index: number) => {
                            const activeMenu = ((role === PTA_ROLE && location.pathname === PATH_ADDRESSES?.PTA_MEETINGS_PATH)) ? (item?.id === selectedCategory?.mcCode) : location.pathname.includes(item.link);
                            return (
                                <div className='menuParentContainer' key={item.id}>
                                    <div onClick={() => onMenuClick(item)} className={`menu ${activeMenu ? "menuActive" : ""}`} key={item.id}>
                                        <div className='menuIconContainer'>
                                            <img className={`menuIcon ${(role === PTA_ROLE && index > 0)? "ptaMenuIcon" : ""} `} alt="sidebarIcons" src={activeMenu ? item?.activeIcon : item.inactiveIcon}/>
                                        </div>
                                        <div className={`menuLabel ${activeMenu ? "menuActive" : ""}`}><span>{item.label}</span></div>
                                        {item?.notificationKey && notification && (notification[item.notificationKey as keyof NotificationType] ?? 0) > 0 && (
                                            <span className='notificationBadge'>{notification[item.notificationKey as keyof NotificationType]}</span>
                                        )}
                                        {item?.id === 'SystemMessages' && role === SCHOOL_ADMIN && (systemMessageCount ?? 0) > 0 && (
                                            <span className='notificationBadge'>{systemMessageCount}</span>
                                        )}
                                    </div>
                                    {item.hasSubmenu && (
                                        <div className="submenu-ctn">
                                            {item.submenus && item.submenus.map((submenu: any) => {
                                                const isActiveTab = (location.pathname === PATH_ADDRESSES?.TEACHER_PTA_PATH && item?.id === "PTAMeetings" && submenu?.id === selectedCategory?.mcCode) || (location.pathname === PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH && item?.id === "Classroom" && activeTab === submenu.index);
                                                return (
                                                    <div key={submenu.id} onClick={()=>handleSubmenuClick(submenu)} 
                                                    className={`submenuItem ${isActiveTab ? 'submenuactiveTab' : ''}`}
                                                    >
                                                        {submenu.label}
                                                        <span 
                                                        className="redDot" 
                                                        style={{ 
                                                            visibility:  submenu.index === 0 && isMylibaryActive ? 'visible' : 
                                                            submenu.index === 1 && isquizActive ? 'visible' : 
                                                            submenu.index === 2 && isAssignmentActive ? 'visible' :
                                                            submenu.index === 4 && isLiveActive ? 'visible' :
                                                            'hidden'
                                                        }}
                                                        />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )}
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div  className='sidebarBottomContainer'>
                    <div className='menuItems'>
                        {getMenuItemsBySet("setTwo").map((item) => {
                            const activeMenu = location.pathname.includes(item.link);
                            return (
                                <div className='menuParentContainer'>
                                    <div onClick={() => onMenuClick(item)} className={`menu`} key={item.id}>
                                        <div className='menuIconContainer'>
                                            <img className="menuIcon" alt="sidebarIcons" src={activeMenu ? item?.activeIcon : item.inactiveIcon}/>
                                        </div>
                                        <div className={`menuLabel ${activeMenu ? "menusetTwoActive" : ""}` }><span>{item.label}</span></div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className='logoutContainer'>
                        {getMenuItemsBySet("setThree").map((item) => (
                            <div onClick={onLogoutClick} className='menu' key={item.id}>
                                <img className="menuIcon" alt="sidebarIcons" src={item.inactiveIcon}/>
                                <div className="menuLabel"><span>{item.label}</span></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <ConfirmationPopup
                open={openConfirmationPopup}
                message={logoutMessage}
                gifData={logoutGif}
                yesButtonFunctionality={onYesButtonClick}
                noButtonFunctionality={onNoButtonClick}
                messageWidth={getScreenDimensions()?.width > 768 ? '345px' : '230px'}
                popupContainerHeight={(getIsJoinedLocalValue() === 'joined') ? '230px' : '202px'}
            />
        </Drawer>
    )
}

export default MobileSidebar;
